import * as React from 'react';

import { TModifier } from '../../../../../packages/Filters';
import { TFilterType } from '../../../types/filterType';
import { GEO_CHANGE_ACTIONS } from '../constants';

const FilterTypeMap: Record<
  'GEO' | 'DATES' | 'PRICE' | 'LIVING_CONDITIONS',
  { name: TFilterType; modifiersActions: TModifier['action'][] }
> = {
  GEO: {
    name: 'geo',
    modifiersActions: GEO_CHANGE_ACTIONS,
  },
  DATES: {
    name: 'dates',
    modifiersActions: ['setDates'],
  },
  LIVING_CONDITIONS: {
    name: 'living_conditions',
    modifiersActions: ['setBeds', 'setLivingConditions'],
  },
  PRICE: {
    name: 'price',
    modifiersActions: ['setPrice', 'setPriceMax', 'setPriceMin'],
  },
};

export const useLastChangedFilterType = () => {
  const [lastAppliedModifiers, setLastAppliedModifiers] = React.useState<TModifier[]>([]);

  const lastChangedFilterType = React.useMemo(
    () =>
      Object.values(FilterTypeMap).find(val => val.modifiersActions.includes(lastAppliedModifiers[0]?.action))?.name,
    [lastAppliedModifiers],
  );

  return { lastChangedFilterType, setLastAppliedModifiers };
};
